import { Card, Tag, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { BoxedCallout } from 'modules/performance_process/components/common/BoxedCallout'

interface Props {
  value: boolean
  disabled?: boolean
  title: string
  description?: string
  onChange: (value: boolean) => void
  checkboxAriaLabel?: string
  isBetaFeature?: boolean
  infoCalloutDescription?: string
}

export const SettingsToggle: React.FC<Props> = ({
  value,
  onChange,
  disabled,
  title,
  description,
  checkboxAriaLabel,
  isBetaFeature = false,
  infoCalloutDescription,
}) => (
  <Card onClick={disabled ? undefined : () => onChange(!value)}>
    {isBetaFeature && (
      <Card.Eyebrow>
        <Tag type="tangerine">{i18n.t('performance_process.reviews.common.beta')}</Tag>
      </Card.Eyebrow>
    )}
    <Card.Title
      size="small"
      action={
        <TogglerCheckbox
          value={value}
          onChange={onChange}
          disabled={disabled}
          aria-label={checkboxAriaLabel}
        />
      }
    >
      {title}
    </Card.Title>
    {description !== undefined && <Card.Description>{description}</Card.Description>}
    {infoCalloutDescription !== undefined && (
      <Card.Content>
        <BoxedCallout fullWidth description={infoCalloutDescription} />
      </Card.Content>
    )}
  </Card>
)
